export default (calendarData, pageData) => {

  const c = {
    calendarData,
    pageData
  };
  const init = () => {
    console.log('buildCalendaer', c);
    c.root = document.querySelector('.le-calendar');

    buildCalenderHead();
    buildCalenderBody();
  }

  const buildCalenderHead = () => {
    const headEle = c.root.querySelector('.le-calendar__head');
    headEle.querySelector('.le-calendar__ym-year').textContent = pageData.displayYear;
    headEle.querySelector('.le-calendar__ym-month').textContent = pageData.displayMonth;

    headEle.classList.remove('_skelton');
    headEle.removeAttribute('aria-hidden');
  }
  const buildCalenderBody = () => {
    const bodyEle = c.root.querySelector('.le-calendar__body');

    const calenderPage = bodyEle.querySelector('.le-calendar__slide');

    const pageFragment = document.createDocumentFragment();
    c.calendarData.forEach(monthPageData => {
      const cloneCalenderPage = calenderPage.cloneNode(true);
      cloneCalenderPage.dataset.year = monthPageData.year;
      cloneCalenderPage.dataset.month = monthPageData.month;

      cloneCalenderPage.innerHTML = monthPageData.str;

      pageFragment.appendChild(cloneCalenderPage);
    });

    const pageContainer = bodyEle.querySelector('.le-calendar__wrapper');
    pageContainer.innerHTML = '';
    pageContainer.appendChild(pageFragment);

    bodyEle.classList.remove('_skelton');
    bodyEle.removeAttribute('aria-hidden');

    // swiperの構築
    const calenderContainer = bodyEle.querySelector('.le-calendar__container');
    calenderContainer.build();
  }

  init();
}
